module.exports = __webpack_public_path__ + "static/img/icon_yc.29b3a982.png";